export default {
      id: "icon--datepicker-arrow-blue-usage",
      viewBox: "0 0 21 21",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--datepicker-arrow-blue-usage",
      toString: function () {
        return this.url;
      }
    }